(function() {
  var store;
  var __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
  store = window.Store || (window.Store = {});
  store.Views = store.Views || (store.Views = {});
  store.Views.CartView = Backbone.View.extend({
    anim: {
      ease: 'easeOutQuint',
      speed: 300
    },
    events: {
      'click div.remove': 'removeItem'
    },
    items: [],
    initialize: function(options) {
      this.els = {
        $itemCount: this.$('span.item-count'),
        $totalPrice: this.$('span.total-price'),
        $contents: this.$('div.contents')
      };
      _.bindAll(this, 'getCartData');
      this.getCartData();
      this.appModel = options.appModel;
      this.model = new Backbone.Model();
      this.appModel.bind('cart-updated', this.getCartData);
    },
    getCartData: function() {
      $.ajax({
        url: '/cart.js',
        dataType: 'json',
        success: __bind(function(data) {
          this.cartLoaded(data);
        }, this)
      });
    },
    cartLoaded: function(data) {
      this.model.set(data);
      this.render();
    },
    render: function() {
      var item, _i, _len, _ref;
      this.items = [];
      this.els.$itemCount.html(this.model.get('item_count'));
      this.els.$totalPrice.html(this.model.get('total_price') / 100);
      _ref = this.model.get('items');
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        item = _ref[_i];
        this.updateItems(item);
      }
      this.updateItemXposition();
    },
    updateItemXposition: function() {
      $.each(this.items, __bind(function(i, id) {
        this.$('#cart-item-' + id).animate({
          left: 86 * i
        }, this.anim.speed, this.anim.ease);
      }, this));
    },
    updateItems: function(item) {
      this.items.push(item.id);
      if (this.$('#cart-item-' + item.id).length > 0) {
        this.$('#cart-item-' + item.id + ' span.quantity').text(item.quantity);
      } else {
        $.tmpl('cart-item', item).appendTo(this.els.$contents);
        this.animateItemIn(item.id);
      }
    },
    animateItemIn: function(id) {
      var $item, n;
      n = this.items.indexOf(id);
      $item = this.$('#cart-item-' + id);
      $item.css({
        left: n * 86
      });
      $item.fadeTo(0, 0);
      $item.animate({
        top: 0,
        opacity: 1
      }, this.anim.speed, this.anim.ease);
    },
    animateItemOut: function(id) {
      var $item;
      $item = this.$('#cart-item-' + id);
      $item.animate({
        opacity: 0,
        top: 200
      }, this.anim.speed, this.anim.ease, function() {
        $(this).remove();
      });
    },
    removeItem: function(e) {
      var $rem, id;
      e.preventDefault();
      if (window.confirm('remove this item?')) {
        $rem = $(e.currentTarget);
        id = $rem.attr('data-variant-id');
        $('#cart-item-' + id).addClass('removed');
        $.ajax({
          url: '/cart/change.js',
          dataType: 'json',
          type: 'POST',
          data: {
            id: id,
            quantity: 0
          },
          success: __bind(function(data) {
            this.animateItemOut(id);
            this.getCartData();
          }, this)
        });
      }
    }
  });
}).call(this);
